import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "next/link";
import { Trans } from "@lingui/macro";
import { Box } from "@mui/material";

interface BreadCrumbsProps {
  title: string;
  link?: string | null;
}
const CustomBreadcrumbs = ({ crumbs }: { crumbs: BreadCrumbsProps[] }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mt: { xs: 0, md: 2 },
        pb: "10px",
        overflowX: "auto",
      }}
    >
      <Link href="/" prefetch={false}>
        <p className="inline cursor-pointer text-sm text-primary duration-300 ease-in hover:text-black">
          <Trans>Home</Trans>
        </p>
      </Link>
      <Box
        sx={{
          height: "12px",
          width: "1px",
          backgroundColor: "#00000099",
          mx: 2,
          flexShrink: 0,
        }}
      ></Box>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator="›"
        sx={{
          "& .MuiBreadcrumbs-separator": { mx: "12px" },
          "& .MuiBreadcrumbs-ol": {
            flexWrap: "nowrap",
          },
          scrollbarWidth: "thin",
        }}
      >
        {crumbs?.map((crumb: any, index: number) => {
          const isLast = index === crumbs.length - 1;
          return crumb.link && !isLast ? (
            <Link prefetch={false} key={index} href={crumb.link} passHref className="block w-max">
              <p className="text-sm text-primary duration-300 ease-in hover:text-black">
                {crumb.title}
              </p>
            </Link>
          ) : (
            <p key={index} className={`w-max text-sm text-black duration-300 ease-in`}>
              {crumb.title}
            </p>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default CustomBreadcrumbs;
